export const SERVICE_KEY = 'payments-api';
//# sourceMappingURL=constants.js.map